import { computed, unref } from 'vue';

const settingEnabled = value => value === true || value === 'true' || value === 1 || value === '1';

export function createProjectMaintenanceWidget({ sheet, record, tenantSettings }) {
    const actions = computed(() => {
        const currentSheet = unref(sheet);
        const currentRecord = unref(record);
        if (
            currentSheet?.name !== 'project'
            || !currentRecord?.id
            || !settingEnabled(unref(tenantSettings)?.['feature.maintenance'])
            || !currentRecord.project_scopes?.some(scope => scope?.name === 'Monitoraggi')
        ) {
            return [];
        }

        const projectId = encodeURIComponent(String(currentRecord.id));
        const parkIds = [
            currentRecord.parkId,
            ...(currentRecord.parks ?? []).map(park => park?.id),
        ].filter(Boolean).map(String).filter((id, index, source) => source.indexOf(id) === index);
        const siteQuery = parkIds.length === 1
            ? `&prefill_park_id=${encodeURIComponent(parkIds[0])}`
            : '';
        return [{
            id: 'project-new-degradation',
            label: 'Nuovo degrado',
            icon: 'location-marker',
            tone: 'red',
            href: `/database/nuova-scheda/maintenance_degradation?prefill_project_id=${projectId}${siteQuery}`,
        }, {
            id: 'project-new-intervention',
            label: 'Nuovo intervento',
            icon: 'helmet',
            tone: 'green',
            href: `/database/nuova-scheda/maintenance_intervention?prefill_project_id=${projectId}${siteQuery}`,
        }];
    });

    return {
        slot: 'scheda:before-content-actions',
        actionBlocks: computed(() => actions.value.length ? [{
            id: 'project-maintenance-actions',
            label: 'Manutenzione',
            actions: actions.value,
        }] : []),
    };
}